module.exports = __webpack_public_path__ + "img/tooltip_02-VALLONE_FINISH_HST_K23_LEGNO_SUMMER.9b026193.jpg";